export class SFDCEvent {
    eventId: number;
    eventName: string;
    eventUrl: string;
}